@if (message != null) {
  <div class="alert alert-{{ type }} w-100" [ngClass]="cssClass" [attr.id]="id" [style.margin-top]="marginTop" [style.margin-right]="marginRight" [style.margin-bottom]="marginBottom" [style.margin-left]="marginLeft">
    <span class="bi bi-info-square-fill me-2"></span>
    <span>{{ message }}</span>
  </div>
}